import { addProtocol, AddProtocolAction, RasterTileSource } from 'maplibre-gl';
import { WeatherSettingsChangeSource } from '../../settings/settings';
import { MessageType } from '../../worker/actor/actor-messages';
import { WeatherLayerBase } from '../weather-layer-base';

export class RasterTileLayer extends WeatherLayerBase {
    source: RasterTileSource | null = null;

    protected onAdd(): void {
        addProtocol(`fe-weather-${this.baseId}`, this.load);

        this.map.addSource(this.baseId, {
            type: 'raster',
            tiles: this.buildTileUrl(),
            tileSize: 256
            // bounds: TODO: each product has bounds, make use of them here!
        });

        this.source = this.map.getSource<RasterTileSource>(this.baseId) ?? null;
        this.map.addLayer(
            {
                id: this.baseId,
                type: 'raster',
                source: this.baseId,
                layout: {
                    visibility: this.shouldDisplay() ? 'visible' : 'none'
                }
            },
            this.slotTopLayerId
        );
    }

    protected onRemove(): void {
        this.map.removeLayer(this.baseId);
        this.map.removeSource(this.baseId);
        this.source = null;
    }

    private load: AddProtocolAction = async (requestParameters) => {
        if (this.visibleFrame === null) {
            throw new Error('Cannot load the tile');
        }

        const coords = requestParameters.url
            .split('://')[1]
            .split('-')
            .map((x) => +x);

        const response = await this.dispatcher.dispatch({
            type: MessageType.getRasterTile,
            data: {
                z: coords[0],
                x: coords[1],
                y: coords[2],
                product: this.productId,
                frame: this.visibleFrame,
                tileSize: 256,
                workspaceId: this.workspaceId
            }
        });

        if (!response) {
            throw new Error('Cannot load the tile');
        }

        return {
            data: response
        };
    };

    protected onSettingsUpdated(source: WeatherSettingsChangeSource): void {
        if (
            source === WeatherSettingsChangeSource.windsBarbsColor ||
            source == WeatherSettingsChangeSource.windsTemp ||
            source == WeatherSettingsChangeSource.windsBarbSize
        ) {
            this.source?.load(true);
        }
    }

    protected loadFrame(frameId: number) {
        this.source?.load(true);
        return Promise.resolve();
    }

    protected onDisplayChanged(): void {
        this.map.setLayoutProperty(this.baseId, 'visibility', this.shouldDisplay() ? 'visible' : 'none');
    }

    private buildTileUrl(): string[] {
        return [`fe-weather-${this.baseId}://{z}-{x}-{y}`];
    }
}
